"use client";

import React from 'react';
import { Upload, Mic } from "lucide-react";

export type TabMode = "upload" | "record";

interface TabToggleProps {
  activeTab: TabMode;
  switchTab: (tab: TabMode) => void;
}

export const TabToggle: React.FC<TabToggleProps> = ({ activeTab, switchTab }) => {
  return (
    <div className="mt-3">
      {/* タブコンテナ */}
      <div className="relative flex bg-gray-100 dark:bg-gray-800 rounded-full p-1 mx-auto w-full">
        {/* スライドする背景要素 - CSSで制御 */}
        <div 
          className={`absolute top-1 bottom-1 bg-black dark:bg-white w-[calc(50%-2px)] rounded-full transition-all duration-300 ease-in-out ${
            activeTab === "upload" 
              ? "left-1" 
              : "left-[calc(50%)]"
          }`}
        />
        
        {/* ファイルアップロードタブ */}
        <button
          type="button"
          onClick={() => switchTab("upload")}
          className={`relative z-10 flex items-center py-2.5 px-5 rounded-full whitespace-nowrap transition-colors duration-300 min-w-0 flex-1 justify-center cursor-pointer ${
            activeTab === "upload"
              ? "text-white dark:text-black font-medium"
              : "text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          }`}
          aria-label="ファイルアップロード"
        >
          <Upload 
            size={16} 
            className={`mr-2 flex-shrink-0 transition-transform duration-200 ${
              activeTab === "upload" ? "scale-105" : ""
            }`} 
          />
          <span className="truncate">ファイル</span>
        </button>
        
        {/* 音声録音タブ */}
        <button
          type="button" 
          onClick={() => switchTab("record")}
          className={`relative z-10 flex items-center py-2.5 px-5 rounded-full whitespace-nowrap transition-colors duration-300 min-w-0 flex-1 justify-center cursor-pointer ${
            activeTab === "record"
              ? "text-white dark:text-black font-medium"
              : "text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          }`}
          aria-label="音声録音"
        >
          <Mic 
            size={16} 
            className={`mr-2 flex-shrink-0 transition-transform duration-200 ${
              activeTab === "record" ? "scale-105" : ""
            }`} 
          />
          <span className="truncate">録音</span>
        </button>
      </div>
    </div>
  );
};

export default TabToggle;